module.exports = __webpack_public_path__ + "static/img/wonderlabs.2f83a91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wonderlabs.png
// module id = 36
// module chunks = 1